/* NodOff theme scripts */
(function () {
  'use strict';
  var N = window.NodOff || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || N.moneyFormat || '${{amount}}';
    var value = '';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return '0';
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(re);
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(re, value);
  }
  N.formatMoney = formatMoney;

  /* ---------- Announcement rotation + countdown ---------- */
  function initAnnouncement() {
    $$('[data-announce]').forEach(function (bar) {
      var msgs = $$('.announce__msg', bar);
      if (msgs.length > 1) {
        var i = 0;
        setInterval(function () {
          msgs[i].classList.remove('is-active');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('is-active');
        }, parseInt(bar.getAttribute('data-speed') || '4', 10) * 1000);
      }
    });
    $$('[data-countdown]').forEach(function (el) {
      var raw = el.getAttribute('data-countdown');
      var end = raw ? new Date(raw.replace(' ', 'T')) : null;
      var wrap = el.closest('[data-countdown-wrap]') || el;
      if (!end || isNaN(end.getTime()) || end.getTime() <= Date.now()) { wrap.style.display = 'none'; return; }
      var d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end.getTime() - Date.now());
        if (diff <= 0) { wrap.style.display = 'none'; clearInterval(t); return; }
        var sec = Math.floor(diff / 1000);
        d.textContent = pad(Math.floor(sec / 86400));
        h.textContent = pad(Math.floor((sec % 86400) / 3600));
        m.textContent = pad(Math.floor((sec % 3600) / 60));
        s.textContent = pad(sec % 60);
      }
      tick();
      var t = setInterval(tick, 1000);
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var menu = $('#MobileMenu');
    if (!menu) return;
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); }); });
    $$('[data-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); }); });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = $('[data-gallery-track]', root);
    if (!track) return null;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('.gallery__thumb', root);
    function go(i, smooth) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function setActive(i) { thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var timer;
    track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(function () { setActive(current()); }, 80); }, { passive: true });
    return {
      showColor: function (color) {
        if (!color) return;
        var c = color.toLowerCase();
        for (var i = 0; i < slides.length; i++) {
          var tag = (slides[i].getAttribute('data-color') || '').toLowerCase();
          if (tag && tag.indexOf(c) !== -1) { go(i); return; }
        }
      }
    };
  }

  /* ---------- Buy box (offers, colors, gifts, upsells, ATC) ---------- */
  function initBuyBox(root) {
    var gallery = initGallery(root);
    var offers = $$('[data-offer]', root);
    var gifts = $$('[data-gift]', root);
    var upsells = $$('[data-upsell] input', root);
    var btn = $('[data-atc]', root);
    var btnLabel = $('[data-atc-label]', root);
    var btnPrice = $('[data-atc-price]', root);
    var errorEl = $('[data-atc-error]', root);
    var sticky = document.querySelector('[data-sticky-atc="' + root.getAttribute('data-section') + '"]');
    var fallbackVariant = root.getAttribute('data-variant');

    function selected() { return offers.filter(function (o) { return o.classList.contains('is-selected'); })[0] || offers[0]; }

    function updateGifts() {
      var o = selected();
      var idx = o ? parseInt(o.getAttribute('data-index'), 10) : 1;
      gifts.forEach(function (g) {
        var need = parseInt(g.getAttribute('data-unlock') || '1', 10);
        g.classList.toggle('is-locked', idx < need);
      });
    }

    function total() {
      var o = selected();
      var t = o ? parseInt(o.getAttribute('data-price') || '0', 10) : parseInt(root.getAttribute('data-price') || '0', 10);
      upsells.forEach(function (u) { if (u.checked) t += parseInt(u.getAttribute('data-price') || '0', 10); });
      return t;
    }

    function refresh() {
      updateGifts();
      var price = formatMoney(total());
      if (btnPrice) btnPrice.textContent = price;
      if (sticky) {
        var sp = $('[data-sticky-price]', sticky);
        if (sp) sp.textContent = price;
        var so = $('[data-sticky-offer]', sticky);
        var o = selected();
        if (so && o) so.textContent = o.getAttribute('data-title') || '';
      }
    }

    offers.forEach(function (o) {
      o.addEventListener('click', function (e) {
        if (e.target.closest('.swatch')) return;
        offers.forEach(function (x) { x.classList.remove('is-selected'); var r = $('input[type=radio]', x); if (r) r.checked = false; });
        o.classList.add('is-selected');
        var r = $('input[type=radio]', o); if (r) r.checked = true;
        refresh();
      });
      $$('.color-row', o).forEach(function (row) {
        var label = $('[data-color-name]', row);
        $$('.swatch', row).forEach(function (sw) {
          sw.addEventListener('click', function (e) {
            e.preventDefault();
            $$('.swatch', row).forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
            sw.classList.add('is-active'); sw.setAttribute('aria-pressed', 'true');
            if (label) label.textContent = sw.getAttribute('data-color');
            if (gallery) gallery.showColor(sw.getAttribute('data-color'));
          });
        });
      });
    });
    upsells.forEach(function (u) { u.addEventListener('change', refresh); });

    function buildItems() {
      var o = selected();
      var props = {};
      var variantId = o ? o.getAttribute('data-variant') : fallbackVariant;
      if (o) {
        $$('.color-row', o).forEach(function (row, i) {
          var a = $('.swatch.is-active', row);
          if (a) props['Pillow ' + (i + 1) + ' color'] = a.getAttribute('data-color');
        });
      }
      var giftNames = gifts.filter(function (g) { return !g.classList.contains('is-locked'); }).map(function (g) { return g.getAttribute('data-name'); });
      if (giftNames.length) props['Free gifts'] = giftNames.join(', ');
      var items = [{ id: parseInt(variantId, 10), quantity: 1, properties: props }];
      upsells.forEach(function (u) { if (u.checked && u.getAttribute('data-variant')) items.push({ id: parseInt(u.getAttribute('data-variant'), 10), quantity: 1 }); });
      return items;
    }

    function addToCart() {
      if (!btn) return;
      var items = buildItems();
      if (!items[0].id) { showError('This product has no variant set up yet. Check the setup steps.'); return; }
      btn.setAttribute('disabled', 'disabled');
      var orig = btnLabel ? btnLabel.textContent : '';
      if (btnLabel) btnLabel.textContent = 'Adding…';
      showError('');
      fetch(N.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
          if (N.cartType === 'page') { window.location.href = N.routes.cartPage; return; }
          Cart.open();
        })
        .catch(function (err) { showError(err.message); })
        .then(function () { btn.removeAttribute('disabled'); if (btnLabel) btnLabel.textContent = orig; });
    }
    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg; errorEl.classList.toggle('is-visible', !!msg); }

    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });

    if (sticky && btn) {
      var sbtn = $('[data-sticky-btn]', sticky);
      if (sbtn) sbtn.addEventListener('click', function () { addToCart(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var below = en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !en.isIntersecting && below);
          });
        }).observe(btn);
        document.body.classList.add('has-sticky-atc');
      }
    }
    refresh();
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    el: null,
    init: function () {
      this.el = $('#CartDrawer');
      if (!this.el) return;
      var self = this;
      $$('[data-drawer-close]', this.el).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { if (N.cartType === 'page') return; e.preventDefault(); self.open(); });
      });
      this.el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-line]');
        if (!b) return;
        self.change(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-qty'), 10));
      });
    },
    open: function () {
      if (!this.el) { window.location.href = N.routes.cartPage; return; }
      this.refresh();
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    },
    change: function (line, qty) {
      var self = this;
      fetch(N.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (c) { self.render(c); });
    },
    refresh: function () {
      var self = this;
      return fetch(N.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { self.render(c); });
    },
    render: function (cart) {
      $$('[data-cart-count]').forEach(function (e) { e.textContent = cart.item_count; e.setAttribute('data-count', cart.item_count); });
      if (!this.el) return;
      var wrap = $('[data-cart-items]', this.el);
      $('[data-cart-total]', this.el).textContent = formatMoney(cart.total_price);
      var checkout = $('[data-checkout]', this.el);
      if (!cart.items.length) {
        wrap.innerHTML = '<p class="drawer__empty">Your cart is empty.</p>';
        checkout.setAttribute('disabled', 'disabled'); checkout.style.pointerEvents = 'none'; checkout.style.opacity = '.5';
        return;
      }
      checkout.removeAttribute('disabled'); checkout.style.pointerEvents = ''; checkout.style.opacity = '';
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
      wrap.innerHTML = cart.items.map(function (it, i) {
        var line = i + 1;
        var props = '';
        if (it.properties) {
          Object.keys(it.properties).forEach(function (k) {
            if (k.charAt(0) === '_' || !it.properties[k]) return;
            props += '<div>' + esc(k) + ': ' + esc(it.properties[k]) + '</div>';
          });
        }
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') === -1 ? '?' : '&') + 'width=200') + '" alt="" loading="lazy">' : '';
        var compare = it.original_line_price > it.final_line_price ? ' <s style="color:#8a93a3;font-weight:400;font-size:.8rem">' + formatMoney(it.original_line_price) + '</s>' : '';
        return '<div class="line">' +
          '<a class="line__img" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="line__info">' +
            '<div class="line__title">' + esc(it.product_title) + '</div>' +
            (it.variant_title ? '<div class="line__variant">' + esc(it.variant_title) + '</div>' : '') +
            (props ? '<div class="line__props">' + props + '</div>' : '') +
            '<div class="line__bottom">' +
              '<div class="qty"><button type="button" data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
              '<div class="line__price">' + formatMoney(it.final_line_price) + compare + '</div>' +
            '</div>' +
            '<button type="button" class="line__remove" data-line="' + line + '" data-qty="0">Remove</button>' +
          '</div></div>';
      }).join('');
    }
  };
  N.Cart = Cart;

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initMenu();
    initReveal();
    Cart.init();
    $$('[data-buy-box]').forEach(initBuyBox);
    $$('[data-gallery-only]').forEach(initGallery);
  });
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-buy-box]', e.target).forEach(initBuyBox);
    initReveal();
    initAnnouncement();
  });
})();
